// eslint-disable-next-line no-unused-vars

const debug = false;
export class ESDImageScaler {
    constructor (options) {

        this.dbg = debug ? console.log.bind(window.console, '[ESDImageScaler]') : () => {};

        const w = 144;
        const h = 144; //w * 9 / 16
        this.canvas = document.createElement('canvas');
        this.canvas.width = options && options.width ? options.width : w;
        this.canvas.height = options && options.height ? options.height : h;

        this.defaultImageName = 'streamdeck.jpg';
        this.coverMode = true;

        // const isDataURL = (s) => !!s.match(isDataURL.regex);

        const isDataURL = (s) => {
            return !!s.match(isDataURL.regex);
        };
        // eslint-disable-next-line
        isDataURL.regex = /^\s*data:([a-z]+\/[a-z]+(;[a-z\-]+\=[a-z\-]+)?)?(;base64)?,[a-z0-9\!\$\&\'\,\(\)\*\+\,\;\=\-\.\_\~\:\@\/\?\%\s]*\s*$/i;
        this.isDataURL = isDataURL;
    }

    loadImage(imgPathOrFileobj, callback) {
        return this.loadImageP(imgPathOrFileobj).then(dataUrl => {
            if(callback) callback(dataUrl);
            return dataUrl;
        });
    }
    loadImageP(imgPathOrFileobj) {
        this.dbg('loadImageP', imgPathOrFileobj);
        if(typeof imgPathOrFileobj == 'object' && imgPathOrFileobj.fullPath) {
            console.log('xxx imgPathOrFileobj', imgPathOrFileobj);
            // return this.loadAndScaleImage(imgPathOrFileobj.fullPath, true);
            return '';
        } else if(imgPathOrFileobj instanceof Blob) {
            return this.loadAndScaleImage(URL.createObjectURL(imgPathOrFileobj), true);
        } else if(imgPathOrFileobj instanceof File) {
            return this.loadAndScaleImage(URL.createObjectURL(imgPathOrFileobj), true);
        } else if(typeof imgPathOrFileobj === 'string' && this.isDataURL(imgPathOrFileobj)) {
            return this.loadAndScaleImage(imgPathOrFileobj);

            // } else if(typeof imgPathOrFileobj == 'object' && imgPathOrFileobj.image) {
            //     this.loadImage(URL.createObjectURL(imgPathOrFileobj.image), imgPathOrFileobj.properties.path, true);
        } else if(typeof imgPathOrFileobj === 'string'){
            const imageSrc = imgPathOrFileobj.includes('/') ? imgPathOrFileobj : `images/${imgPathOrFileobj.length ? imgPathOrFileobj : this.defaultImageName}`;
            return this.loadAndScaleImage(imageSrc);
        }

        return Promise.reject('');
    }
    loadAndScaleImage(imageSrc, revokeObjectURL = false) {
        this.dbg("ESDImageLoader::loadImage", imageSrc);
        return new Promise(resolve => {
            let image = new Image();
            image.onload = () => {
                this.scaleAndDrawImage(image);
                if(revokeObjectURL) URL.revokeObjectURL(imageSrc);
                image = null;
                const dataUrl = this.canvas.toDataURL('image/png');
                resolve(dataUrl);
            };
            image.src = imageSrc;
        });

    }
    scaleAndDrawImage(img) {
        const ctx = this.canvas.getContext('2d');
        const canvas = this.canvas;
        const ratio = this.coverMode === true ? Math.max(canvas.width / img.width, canvas.height / img.height) : Math.min(canvas.width / img.width, canvas.height / img.height);
        const centerX = (canvas.width - img.width * ratio) / 2;
        const centerY = (canvas.height - img.height * ratio) / 2;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        // this.dbg("centerX/Y", centerX, centerY, "ratio:", ratio);
        ctx.drawImage(img, 0, 0, img.width, img.height, centerX, centerY, img.width * ratio, img.height * ratio);
    }
}
